import type { CSSProperties, InputHTMLAttributes } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'

interface InputProps extends InputHTMLAttributes<HTMLInputElement>{
  register?: UseFormRegisterReturn
  label: string
  inputStyle?: CSSProperties
  auto?: boolean
}

const inputStyles: CSSProperties = {
  visibility: 'visible',
  fontSize: '12px',
  cursor: 'text',
  lineHeight: '14px',
  letterSpacing: '0.5px',
  color: '#6e6c6f'
}

export function Input ({ register, label, title, inputStyle, auto, ...rest }: InputProps): JSX.Element {
  const required = rest?.required

  return (
    <div className='flex flex-col gap-1'>
      <label
        style={ inputStyles }
        className='relative w-fit flex flex-row'
        title={title}
      >
        {label}
        {required &&
          <span
            style={{
              position: 'absolute',
              top: '-3px',
              right: '-7px',
              fontSize: '1rem',
              color: 'red'
            }}
          >*
          </span>
        }
        {auto && (
          <span
            title='This field is filled in automatically'
            className='cursor-pointer bg-primary absolute -top-1 -right-4 bg-opacity-10 text-primary text-[8px] w-3 h-3 font-bold rounded-full flex items-center justify-center'
          >
            A
          </span>
        )}
      </label>
      <input
        className='px-3 py-3 border border-solid border-[#DADCE0] rounded-md disabled:bg-gray-100'
        style={{ ...inputStyle }}
        {...rest}
        {...register}
      />
    </div>
  )
}

interface TextareaProps extends InputHTMLAttributes<HTMLTextAreaElement>{
  register?: UseFormRegisterReturn
  label: string
  inputStyle?: CSSProperties
}

export function Textarea ({ register, label, inputStyle, ...rest }: TextareaProps): JSX.Element {
  const required = rest?.required

  return (
    <div className='flex flex-col gap-1 h-full'>
      <label
        style={ inputStyles }
        className='relative w-fit'
      >
        {label}
        {required &&
          <span
            style={{
              position: 'absolute',
              top: '-3px',
              right: '-7px',
              fontSize: '1rem',
              color: 'red'
            }}
          >*
          </span>
        }
      </label>
      <textarea
        className='px-3 py-3 border border-solid border-[#DADCE0] rounded-md disabled:bg-gray-100 h-full'
        style={{ ...inputStyle }}
        {...rest}
        {...register}
      />
    </div>
  )
}
